import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiCard } from 'ui-components';
import { marginRight } from 'utils';

export const StyledGauge = styled(UiCard)(
  ({ theme }) => css`
    &.ui-gauge {
      display: flex;
      flex-direction: column;
      min-width: 0;

      .card-header {
        padding: 0 24px;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        border-bottom: 1px solid ${theme.palette.gray.lighter};

        .title {
          font-size: ${theme.typography.subtitle2.fontSize};
          font-weight: ${theme.typography.subtitle2.fontWeight};
          line-height: ${theme.typography.subtitle2.lineHeight};
          color: ${theme.palette.gray.darkest};
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .actions {
          align-items: center;
          .icon {
            ${marginRight('26px')}
            cursor: pointer;
          }
        }
      }

      .card-body {
        flex: 1;
        justify-content: center;
        align-items: center;
        background-color: ${theme.palette.common.white};
        border-radius: 0 0 8px 8px;
        padding: 16px 24px 24px;
        min-height: 272px;

        .custom-loading,
        .no-data,
        .display-errors {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }

      .gauge-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }

      .gauge-hover-target {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        cursor: default;
      }

      .gauge-chart {
        width: 100%;
        aspect-ratio: 2 / 1;

        svg {
          outline: none;
        }

        .gauge-scale-label {
          fill: ${theme.palette.naturals.black};
          direction: ltr;
        }
      }

      .gauge-summary {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 24px;
        text-align: center;
      }

      .gauge-value {
        font-size: ${theme.typography.subtitle.fontSize};
        font-weight: ${theme.typography.subtitle.fontWeight};
        line-height: ${theme.typography.subtitle.lineHeight};
        color: ${theme.palette.naturals.black};
        /*
         * Plain "direction: ltr" has no bidi effect on an inline element unless
         * paired with unicode-bidi, so without this the leading sign was still
         * resolved under the ambient RTL context and landed on the wrong side.
         */
        direction: ltr;
        unicode-bidi: embed;
      }

      .gauge-label {
        font-size: ${theme.typography.overline.fontSize};
        line-height: 16px;
        color: ${theme.palette.gray.dark};
      }

      .gauge-legend {
        flex-direction: column;
        margin-top: 24px;
        gap: 12px;
        justify-content: center;

        .legend-item {
          align-items: center;
          gap: 8px;
        }

        .legend-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .legend-title,
        .legend-value {
          font-size: ${theme.typography.captionLight.fontSize};
          line-height: 24px;
          color: ${theme.palette.naturals.black};
        }

        .legend-value {
          direction: ltr;
          unicode-bidi: embed;
        }
      }
    }
  `
);
